import React, {useContext, useEffect, useState} from "react";
import {CredentialsContext} from "../../API/CredentialsContext";
import Wrapper from "../../Common/Wrapper";
import FormFieldWrapper from "../../Common/FormFieldWrapper";
import {PrimarySubmitButton} from "../../Common/Button";

const PrintCEWB  = () => {

    const [printState, setPrintState] = useState({
        credential: {},
        consolidatedEbn: ""
    })
    const [requests, setRequests] = useState([])
    const { state, dispatch } = useContext(CredentialsContext)
    const users = state?.credentials || []
    const isSearchButtonDisabled =
        Object.keys(printState.credential).length === 0 ||
        printState.consolidatedEbn === "" ||
        state.loading

    const handleState = (event) => {
        const { name, value } = event.target
        if (name === 'credential') {
            setPrintState(prev => ({
                ...prev,
                [name]: users.find(u => u.id === +value)
            }))
        } else {
            setPrintState(prev => ({
                ...prev,
                [name]: value
            }))
        }
    }

    const handleSearchEWB = async (e) => {
        e.preventDefault()

        window.open(
            `https://prod-1.e-waybill.in/api/e-waybill/print-trip?cewb=${printState.consolidatedEbn}&gstin=${printState.credential.gstNumber}`,
            '_blank',
            )
    }


    return <>
        <Wrapper>
            <form className="col-lg-3 mt-5" onSubmit={handleSearchEWB}>
                <h4>Print Consolidated EWB</h4>
                <FormFieldWrapper>
                    <label htmlFor='credential' className="mb-2">Credential</label>
                    <select
                        className="form-select"
                        id="credential"
                        name="credential"
                        onChange={handleState}
                    >
                        <option>Select</option>
                        {users.map((user, index) => {
                            return (
                                <option key={index} value={user.id}>{user.gstNumber}</option>
                            )
                        })}
                    </select>
                </FormFieldWrapper>
                <FormFieldWrapper>
                    <input
                        className="form-control"
                        type="text"
                        name="consolidatedEbn"
                        id="consolidatedEbn"
                        placeholder="Consolidated E-waybill Number"
                        onChange={handleState}
                    />
                </FormFieldWrapper>
                <FormFieldWrapper>
                    <PrimarySubmitButton
                        disabled={isSearchButtonDisabled}
                    >
                        Search
                    </PrimarySubmitButton>
                </FormFieldWrapper>
            </form>
        </Wrapper>
    </>
}

export default PrintCEWB